// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <svg width="130" height="96" viewBox="280 0 860 793.70667" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs id="defs6">
        <clipPath id="clipPath18" clipPathUnits="userSpaceOnUse">
          <path id="path16" d="M 0,595.28 H 841.89 V 0 H 0 Z" />
        </clipPath>
      </defs>
      <g transform="matrix(1.3333333,0,0,-1.3333333,0,793.70667)" id="g10">
        <g id="g12">
          <g clipPath="url(#clipPath18)" id="g14">
            <g transform="translate(437.0615,224.9284)" id="g20">
              <path
                id="path22"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -19.576,0 -34.01,5.364 -45.438,16.912 l 8.161,8.549 c 8.857,-9.803 20.733,-14.447 36.816,-14.447 21.908,0 33.783,8.096 33.783,24.027 0,12.272 -6.76,18.415 -21.432,19.876 l -18.656,1.724 c -22.589,1.967 -33.783,12.503 -33.783,30.908 0,20.355 15.862,33.604 40.309,33.604 15.387,0 29.594,-4.669 39.387,-12.522 l -7.921,-8.34 c -8.636,6.635 -19.097,10.064 -31.466,10.064 -18.415,0 -28.654,-8.341 -28.654,-22.806 0,-12.254 6.999,-18.405 22.83,-19.867 L 12.129,65.958 C 30.751,64.253 44.964,58.124 44.964,35.041 44.964,13.47 27.512,0 0,0"
              />
            </g>
            <g transform="translate(630.4629,226.3708)" id="g24">
              <path
                id="path26"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -18.161,0 -27.019,12.258 -27.019,30.659 v 126.286 h 11.876 V 30.907 c 0,-13.258 3.968,-19.866 17.254,-19.866 h 8.161 L 10.272,0 Z"
              />
            </g>
            <g transform="translate(656.8506,344.6106)" id="g28">
              <path
                id="path30"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="M 0,0 V 0 H 11.89 V -118.226 H 0 Z m 6.078,21.784 c -4.903,0 -8.857,4.157 -8.857,9.087 0,5.138 3.954,9.314 8.623,9.314 4.87,0 8.857,-4.176 8.857,-9.083 0,-5.161 -3.987,-9.318 -8.623,-9.318"
              />
            </g>
            <g transform="translate(726.6387,224.9284)" id="g32">
              <path
                id="path34"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -19.604,0 -34.083,5.364 -45.498,16.912 l 8.144,8.549 c 8.875,-9.803 20.783,-14.447 36.898,-14.447 21.94,0 33.816,8.096 33.816,24.027 0,12.272 -6.765,18.415 -21.433,19.876 l -18.673,1.724 c -22.668,1.967 -33.862,12.503 -33.862,30.908 0,20.355 15.862,33.604 40.374,33.604 15.401,0 29.627,-4.669 39.419,-12.522 l -7.908,-8.34 c -8.636,6.635 -19.129,10.064 -31.511,10.064 -18.448,0 -28.706,-8.341 -28.706,-22.806 0,-12.254 7,-18.405 22.862,-19.867 L 12.148,65.958 C 30.803,64.253 45.028,58.124 45.028,35.041 45.028,13.47 27.549,0 0,0"
              />
            </g>
            <g transform="translate(564.5967,325.03)" id="g36">
              <path
                id="path38"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 v 0 c -6.382,6.387 -14.973,10.065 -24.562,10.065 -9.558,0 -18.148,-3.678 -24.53,-10.065 -9.811,-9.82 -10.54,-25.77 -10.54,-39.525 0,-13.734 0.729,-29.678 10.54,-39.498 6.382,-6.387 14.972,-10.065 24.53,-10.065 9.589,0 18.18,3.678 24.562,10.065 9.812,9.82 10.539,25.764 10.539,39.498 C 10.539,-25.77 9.812,-9.82 0,0 m 8.346,-87.115 c -8.346,-8.351 -19.637,-12.987 -32.908,-12.987 -13.226,0 -24.53,4.636 -32.867,12.987 -12.525,12.511 -14.728,30.672 -14.728,47.59 0,16.94 2.203,35.119 14.728,47.622 8.337,8.355 19.641,13 32.867,13 13.271,0 24.562,-4.645 32.908,-13 12.498,-12.503 14.718,-30.682 14.718,-47.622 0,-16.918 -2.22,-35.079 -14.718,-47.59"
              />
            </g>
            <g transform="translate(215.9307,342.3015)" id="g40">
              <path
                id="path42"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -11.879,0 -24.396,10.341 -33.908,18.227 -3.46,2.843 -8.096,6.682 -10.142,7.571 -1.738,-0.613 -3.756,-0.143 -5.01,1.364 -1.627,1.921 -1.368,4.783 0.553,6.392 5.106,4.281 11.189,-0.747 20.369,-8.35 C -18.608,17.328 -5.585,6.558 3.166,9.572 5.549,10.406 8.139,9.152 8.945,6.779 9.756,4.406 8.503,1.844 6.153,1.01 4.134,0.309 2.065,0 0,0"
              />
            </g>
            <g transform="translate(131.5942,300.7214)" id="g44">
              <path
                id="path46"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 -0.792,0.087 c -2.457,0.419 -4.116,2.779 -3.678,5.231 1.152,6.571 9.042,6.636 20.972,6.719 12.351,0.091 29.259,0.212 34.023,8.156 1.286,2.143 4.079,2.844 6.217,1.567 2.157,-1.286 2.858,-4.083 1.553,-6.23 C 50.936,3.221 31.069,3.074 16.567,2.977 12.083,2.931 6.079,2.898 3.921,2.263 3.12,0.88 1.626,0 0,0"
              />
            </g>
            <g transform="translate(145.0552,224.4167)" id="g48">
              <path
                id="path50"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -1.577,0 -3.092,0.811 -3.936,2.271 -3.331,5.779 2.669,10.876 11.757,18.609 9.391,8.018 22.281,18.973 20.82,28.125 -0.406,2.456 1.285,4.797 3.755,5.184 2.493,0.415 4.812,-1.276 5.208,-3.755 C 39.857,36.239 24.747,23.382 13.701,13.981 10.291,11.069 5.701,7.18 4.47,5.304 4.779,3.493 3.944,1.59 2.258,0.604 1.54,0.193 0.779,0 0,0"
              />
            </g>
            <g transform="translate(204.4194,174.6003)" id="g52">
              <path
                id="path54"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 -1.548,0.268 c -6.272,2.286 -4.964,10.064 -2.977,21.83 2.06,12.193 4.88,28.847 -2.111,34.912 -1.908,1.636 -2.096,4.503 -0.47,6.391 1.636,1.904 4.498,2.112 6.405,0.466 C 10.138,54.452 6.839,34.881 4.419,20.59 3.664,16.162 2.682,10.239 2.922,8 4.332,6.807 4.917,4.825 4.253,2.968 3.585,1.157 1.848,0 0,0"
              />
            </g>
            <g transform="translate(281.1113,174.4392)" id="g56">
              <path
                id="path58"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -5.005,0 -8.701,6.304 -13.954,15.239 -6.258,10.656 -14.816,25.245 -24.088,25.407 -2.475,0.032 -4.488,2.092 -4.442,4.584 0.027,2.512 2.032,4.48 4.603,4.48 C -23.53,49.471 -13.479,32.342 -6.129,19.844 -3.857,15.959 -0.825,10.779 0.811,9.24 2.65,9.226 4.396,8.097 5.046,6.24 5.903,3.89 4.695,1.286 2.332,0.447 1.521,0.143 0.746,0 0,0"
              />
            </g>
            <g transform="translate(338.9453,223.3386)" id="g60">
              <path
                id="path62"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -3.921,0 -9.193,1.889 -15.765,4.207 -11.636,4.143 -27.562,9.807 -34.751,3.986 -1.936,-1.589 -4.797,-1.286 -6.364,0.65 -1.59,1.954 -1.286,4.793 0.664,6.373 11.129,9.055 29.847,2.406 43.502,-2.451 4.221,-1.507 9.876,-3.507 12.129,-3.682 1.415,1.188 3.493,1.429 5.175,0.46 C 6.765,8.285 7.512,5.511 6.254,3.35 4.876,0.939 2.779,0 0,0"
              />
            </g>
            <g transform="translate(308.1479,269.5964)" id="g64">
              <path
                id="path66"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 -0.857,0.088 c -2.461,0.47 -4.064,2.843 -3.603,5.313 2.713,14.097 21.335,21.019 34.926,26.06 4.207,1.576 9.83,3.673 11.636,5.005 0.336,1.802 1.765,3.336 3.7,3.678 2.443,0.419 4.811,-1.222 5.24,-3.692 C 52.199,29.885 44.802,27.134 33.623,22.973 22.037,18.664 6.189,12.766 4.461,3.678 4.033,1.516 2.125,0 0,0"
              />
            </g>
            <g transform="translate(300.3052,314.0486)" id="g68">
              <path
                id="path70"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -1.585,0 -3.144,0.852 -3.968,2.345 -6.973,12.535 2.825,29.798 9.982,42.411 2.226,3.908 5.193,9.119 5.718,11.318 -0.921,1.59 -0.811,3.677 0.461,5.171 1.604,1.921 4.475,2.156 6.397,0.571 C 23.686,57.521 19.797,50.664 13.908,40.272 7.824,29.539 -0.539,14.829 3.954,6.732 5.175,4.558 4.396,1.788 2.189,0.571 1.507,0.184 0.746,0 0,0"
              />
            </g>
            <g transform="translate(265.7285,343.0622)" id="g72">
              <path
                id="path74"
                //style="fill:#646262;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#646262"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 -1.622,0.309 c -13.401,5.106 -17,24.664 -19.623,38.922 -0.811,4.405 -1.889,10.318 -2.889,12.336 -1.728,0.636 -2.967,2.295 -2.967,4.263 0,2.327 1.76,4.239 4.032,4.503 h 1.156 c 6.098,-0.526 7.498,-8.148 9.59,-19.466 C -10.083,28.729 -7.037,12.074 1.599,8.765 3.968,7.885 5.125,5.249 4.235,2.908 3.539,1.12 1.807,0 0,0"
              />
            </g>
            <g transform="translate(186.0093,314.0486)" id="g76">
              <path
                id="path78"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -0.756,0 -1.517,0.175 -2.216,0.571 -2.176,1.217 -2.959,3.977 -1.738,6.161 4.502,8.116 -3.866,22.807 -9.963,33.554 -5.89,10.378 -9.77,17.235 -4.668,21.507 1.917,1.608 4.778,1.364 6.391,-0.548 1.244,-1.503 1.383,-3.581 0.452,-5.171 0.539,-2.199 3.493,-7.396 5.723,-11.318 C 1.133,32.156 10.954,14.88 3.958,2.327 3.134,0.843 1.585,0 0,0"
              />
            </g>
            <g transform="translate(178.166,269.5964)" id="g80">
              <path
                id="path82"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -2.129,0 -4.033,1.507 -4.438,3.668 -1.77,9.106 -17.622,15.01 -29.194,19.295 -11.17,4.171 -18.553,6.918 -17.419,13.48 0.447,2.47 2.806,4.129 5.258,3.691 1.936,-0.341 3.351,-1.848 3.691,-3.673 1.802,-1.318 7.429,-3.415 11.637,-4.977 C -16.875,26.42 1.737,19.488 4.456,5.392 4.931,2.936 3.318,0.562 0.867,0.078 Z"
              />
            </g>
            <g transform="translate(147.3735,223.3386)" id="g84">
              <path
                id="path86"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -2.779,0 -4.857,0.939 -6.24,3.35 -1.267,2.161 -0.521,4.935 1.636,6.193 1.709,0.969 3.765,0.747 5.193,-0.46 2.236,0.156 7.899,2.156 12.129,3.673 13.655,4.856 32.36,11.507 43.517,2.47 1.935,-1.572 2.244,-4.429 0.65,-6.383 C 55.304,6.907 52.46,6.604 50.511,8.193 43.327,14.027 27.377,8.35 15.755,4.221 9.184,1.875 3.907,0 0,0"
              />
            </g>
            <g transform="translate(205.2168,174.4392)" id="g88">
              <path
                id="path90"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -0.751,0 -1.53,0.143 -2.355,0.447 -2.359,0.839 -3.567,3.443 -2.701,5.793 0.651,1.857 2.406,2.986 4.24,3 1.627,1.539 4.668,6.719 6.931,10.59 7.337,12.493 17.401,29.641 31.756,29.88 2.442,0.015 4.558,-1.968 4.604,-4.48 0.046,-2.492 -1.954,-4.552 -4.461,-4.584 C 28.756,40.484 20.185,25.895 13.945,15.239 8.691,6.304 4.986,0 0,0"
              />
            </g>
            <g transform="translate(281.9038,174.6003)" id="g92">
              <path
                id="path94"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="M 0,0 C -1.857,0 -3.585,1.157 -4.253,2.968 -4.922,4.825 -4.332,6.807 -2.921,8 c 0.239,2.239 -0.761,8.162 -1.494,12.571 -2.428,14.31 -5.746,33.881 5.116,43.296 1.889,1.646 4.746,1.438 6.396,-0.452 C 8.732,61.513 8.525,58.646 6.636,57.01 -0.35,50.945 2.46,34.259 4.507,22.098 6.512,10.318 7.825,2.554 1.54,0.268 Z"
              />
            </g>
            <g transform="translate(341.2637,224.4167)" id="g96">
              <path
                id="path98"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -0.76,0 -1.539,0.193 -2.253,0.622 -1.701,0.968 -2.526,2.871 -2.222,4.682 -1.221,1.876 -5.811,5.765 -9.207,8.677 -11.069,9.401 -26.18,22.258 -23.927,36.453 0.397,2.479 2.715,4.17 5.208,3.755 2.474,-0.387 4.142,-2.714 3.76,-5.184 C -30.115,39.853 -17.24,28.898 -7.825,20.88 1.272,13.147 7.272,8.05 3.936,2.271 3.083,0.811 1.572,0 0,0"
              />
            </g>
            <g transform="translate(354.7295,300.7307)" id="g100">
              <path
                id="path102"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -1.636,0 -3.129,0.871 -3.922,2.253 -2.161,0.618 -8.161,0.668 -12.655,0.705 -14.498,0.111 -34.373,0.254 -41.737,12.567 -1.286,2.143 -0.59,4.94 1.571,6.226 2.13,1.286 4.922,0.585 6.208,-1.567 4.765,-7.945 21.673,-8.069 34.023,-8.157 C -4.576,11.944 3.317,11.88 4.46,5.332 4.903,2.857 3.239,0.497 0.792,0.064 Z"
              />
            </g>
            <g transform="translate(270.3784,342.3015)" id="g104">
              <path
                id="path106"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -2.064,0 -4.129,0.309 -6.143,1.01 -2.35,0.834 -3.604,3.396 -2.797,5.769 0.811,2.373 3.4,3.627 5.747,2.793 8.764,-3 21.816,7.774 31.34,15.632 9.176,7.622 15.259,12.631 20.37,8.35 1.921,-1.609 2.161,-4.471 0.557,-6.392 C 47.816,25.655 45.802,25.185 44.056,25.816 42.009,24.909 37.374,21.083 33.908,18.227 24.401,10.341 11.89,0 0,0"
              />
            </g>
            <g transform="translate(220.5898,343.0622)" id="g108">
              <path
                id="path110"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 c -1.825,0 -3.548,1.12 -4.23,2.908 -0.899,2.341 0.253,4.977 2.613,5.857 8.636,3.309 11.7,19.964 13.935,32.102 2.083,11.318 3.479,18.94 9.577,19.466 h 1.175 c 2.253,-0.264 4.032,-2.176 4.032,-4.503 0,-1.968 -1.24,-3.627 -2.987,-4.263 C 23.134,49.549 22.038,43.636 21.226,39.231 18.609,24.973 15.037,5.415 1.604,0.309 Z"
              />
            </g>
            <g transform="translate(215.8896,226.6237)" id="g112">
              <path
                id="path114"
                //style="fill:#f08624;fill-opacity:1;fill-rule:evenodd;stroke:none"
                fill="#f08624"
                fillOpacity={1}
                fillRule="evenodd"
                d="m 0,0 v 0 c 1.908,0 3.724,-0.3 5.447,-0.903 12.29,-4.701 15.733,-23.498 18.258,-37.231 0.949,-5.188 2.235,-12.225 3.558,-13.764 1.318,1.539 2.603,8.557 3.553,13.764 2.525,13.733 5.986,32.53 18.212,37.212 C 50.802,-0.3 52.646,0 54.521,0 c 11.032,0 22.894,-9.824 32.434,-17.719 4.239,-3.488 9.479,-7.806 11.575,-8.24 -0.018,2.069 -3.525,8.24 -6.129,12.816 -6.889,12.157 -16.336,28.789 -9.972,40.217 6.765,11.281 25.881,11.429 39.834,11.526 5.304,0.032 12.447,0.078 14.175,1.105 -1.285,1.577 -7.949,4.061 -12.921,5.903 -13.083,4.876 -31.005,11.544 -33.485,24.388 -2.077,12.986 12.466,25.378 23.102,34.433 4.019,3.415 9.415,8.028 10.13,9.945 l -0.43,0.032 c -2.589,0 -7.76,-1.847 -13.257,-3.802 -8.572,-3.036 -19.24,-6.857 -28.305,-6.857 -5.369,0 -9.733,1.364 -13.018,4.009 -9.941,8.622 -6.752,27.457 -4.429,41.231 0.871,5.221 2.065,12.254 1.346,14.161 -1.747,-1.009 -5.364,-7.151 -8.046,-11.709 -7.051,-12.042 -16.733,-28.544 -29.83,-28.761 -13.148,0.217 -22.816,16.719 -29.912,28.761 -2.664,4.558 -6.268,10.7 -8.028,11.709 -0.715,-1.907 0.488,-8.94 1.35,-14.147 2.341,-13.765 5.525,-32.623 -4.369,-41.189 -3.318,-2.701 -7.705,-4.065 -13.055,-4.065 -9.093,0 -19.752,3.802 -28.341,6.857 -5.48,1.955 -10.646,3.789 -13.231,3.789 l -0.438,-0.019 c 0.715,-1.917 6.111,-6.53 10.13,-9.926 10.626,-9.06 25.179,-21.466 23.115,-34.387 -2.484,-12.909 -20.401,-19.595 -33.493,-24.453 -4.95,-1.856 -11.637,-4.326 -12.936,-5.903 1.751,-1.027 8.875,-1.073 14.162,-1.105 13.976,-0.097 33.101,-0.245 39.824,-11.461 6.387,-11.493 -3.055,-28.125 -9.949,-40.268 -2.603,-4.59 -6.11,-10.761 -6.11,-12.811 2.124,0.428 7.336,4.733 11.571,8.221 C -22.89,-9.824 -11.019,0 0,0 m 27.263,-56.6 c -4.779,0 -6.065,7.019 -8.019,17.642 -2.317,12.687 -5.525,30.036 -15.359,33.802 -1.152,0.41 -2.484,0.617 -3.885,0.617 -9.392,0 -20.562,-9.24 -29.53,-16.668 -7.194,-5.927 -11.415,-9.291 -14.752,-9.291 -1.036,0 -1.981,0.318 -2.728,0.936 -3.658,3.096 -0.129,9.291 5.185,18.672 6.373,11.208 15.088,26.554 9.968,35.756 -5.383,8.969 -23.019,9.107 -35.913,9.199 -10.797,0.064 -17.931,0.128 -18.765,4.83 -0.825,4.713 5.862,7.198 15.972,10.967 12.074,4.493 28.627,10.655 30.623,20.991 1.645,10.328 -11.789,21.775 -21.604,30.138 -8.212,6.996 -13.655,11.613 -11.268,15.756 0.59,0.996 1.834,2.175 4.521,2.175 3.364,0 8.387,-1.783 14.765,-4.046 8.235,-2.935 18.516,-6.581 26.807,-6.581 4.341,0 7.673,0.978 10.143,2.977 7.899,6.858 4.963,24.268 2.811,36.969 -1.788,10.645 -2.977,17.687 1.516,19.313 l 1.364,0.245 c 3.931,0 7.212,-5.595 12.189,-14.066 6.526,-11.119 15.461,-26.354 25.991,-26.511 10.475,0.157 19.415,15.392 25.94,26.511 4.968,8.471 8.254,14.066 12.194,14.066 l 1.364,-0.245 c 4.493,-1.645 3.286,-8.668 1.507,-19.313 -2.143,-12.72 -5.097,-30.111 2.876,-37.014 2.428,-1.954 5.746,-2.932 10.096,-2.932 8.286,0 18.544,3.646 26.784,6.581 6.382,2.263 11.396,4.065 14.778,4.065 2.683,0 3.937,-1.198 4.512,-2.194 2.378,-4.143 -3.05,-8.76 -11.277,-15.769 -9.792,-8.35 -23.239,-19.797 -21.589,-30.19 1.986,-10.271 18.543,-16.433 30.626,-20.926 10.13,-3.769 16.798,-6.254 15.955,-10.954 -0.825,-4.715 -7.968,-4.779 -18.751,-4.843 -12.876,-0.092 -30.545,-0.23 -35.959,-9.253 -5.079,-9.148 3.654,-24.494 10.004,-35.702 5.333,-9.381 8.839,-15.576 5.189,-18.654 -0.747,-0.636 -1.7,-0.954 -2.714,-0.954 -3.35,0 -7.571,3.364 -14.765,9.291 -8.967,7.428 -20.148,16.668 -29.544,16.668 -1.382,0 -2.714,-0.207 -3.936,-0.636 C 40.802,-8.922 37.613,-26.271 35.277,-38.958 33.323,-49.581 32.037,-56.6 27.263,-56.6"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
